









































import { Component, Mixins } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import WhiteLabelData from '@/data/WhiteLabelData';
import WhiteLabelModule from '@/store/modules/WhiteLabel';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class ThemeSelectionView extends Mixins(ErrorHandleMixin) {
  TableHead = WhiteLabelData.TableHead;

  WhiteLabelInstance = getModule(WhiteLabelModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  BannerModel = WhiteLabelData.initialModel();

  currentSelection: any = {};

  isOpenRemove = false;

  mode = '';

  file: any = null;

  url: any = null;

  isImage = false;

  searchText = '';

  data = [];

  colors = [];

  partImage = '';

  type = '';

  name = '';

  agent = '';

  async created() {
    await this.fetchSetting();
  }

  async fetchSetting() {
    const res = await this.WhiteLabelInstance.ThemeSelectionSetting();
    if (res.code) {
      this.checkError(res);
    }

    if (res.status.code === 0) {
      this.data = res.data;
    }
  }

  openPreview(url) {
    if (url) {
      window.open(`${url}`);
    }
  }

  async submitData(value) {
    const res = await this.WhiteLabelInstance.UpdateThemeSelectionSetting({ name: value.name });
    this.checkError(res.status);
  }
}
